// How-to-Play Sheet wrapper - Phase 1.13 debug surface.
//
// Phase 2 will load per-game `how-to-play.md` content lazily. Phase 1.13
// only proves the SheetShell mount path by rendering a placeholder.
//
// Mockup: Vault/Design/Mockups/_Notes - How to Play Sheet.md

import { mountSheetShell, type SheetHandle } from '@nostr-gives/components';

export interface HowToPlayOpts {
  gameName: string;
  bodyHtml: string;
}

export function openHowToPlay(opts: HowToPlayOpts): void {
  const content = document.createElement('div');
  content.className = 'how-to-play-content';
  content.innerHTML = opts.bodyHtml;

  const isMobile = window.matchMedia('(max-width: 640px)').matches;
  let sheet: SheetHandle | null = null;

  sheet = mountSheetShell(document.body, {
    title: `How to play ${opts.gameName}`,
    isMobile,
    onClose: (): void => sheet?.destroy(),
    content,
  });
}
